"use client";

import { useCallback } from "react";
import DematAccount from "./DematAccount";
import {
  trackFloatingFabMasterCtaEvent,
  trackTickerStripDisplayBannerButtonClick,
} from "./unifiedCt";
import type { OpenDematFlowBannerProps } from "./OpenDematFloatBanner.types";

interface OpenDematFloatBannerCtaClientProps extends OpenDematFlowBannerProps {
  isFloating?: boolean;
}

const OpenDematFloatBannerCtaClient = ({
  openDematButtonText,
  resumeJourneyText,
  showUnifiedCt,
  compName,
  exchId,
  formattedSymbol,
  nseToken,
  bseToken,
  showTradeNow,
  tradeNowText,
  showBuySellButtons,
  buyText,
  sellText,
  floatingBannerMainText,
  headerName,
  companies,
  modalTitle,
  isFloating = false,
}: OpenDematFloatBannerCtaClientProps) => {
  const trackTickerStripClick = useCallback(
    (ctaText: string) => {
      void trackTickerStripDisplayBannerButtonClick(
        floatingBannerMainText,
        ctaText,
      );
    },
    [floatingBannerMainText],
  );

  const trackFloatingFabMasterCta = useCallback(
    (ctaText: string, submissionStatus: string = "") => {
      void trackFloatingFabMasterCtaEvent(
        headerName ?? "Bajaj Broking",
        ctaText,
        submissionStatus,
      );
    },
    [headerName],
  );

  return (
    <DematAccount
      openDematButtonText={openDematButtonText ?? "Open Demat Account"}
      resumeJourneyText={resumeJourneyText}
      showUnifiedCt={showUnifiedCt ?? true}
      compName={compName}
      exchId={exchId}
      formattedSymbol={formattedSymbol}
      nseToken={nseToken}
      bseToken={bseToken}
      isFloating={isFloating}
      showTradeNow={showTradeNow}
      tradeNowText={tradeNowText}
      showBuySellButtons={showBuySellButtons}
      buyText={buyText}
      sellText={sellText}
      headerName={headerName}
      companies={companies}
      modalTitle={modalTitle}
      onMasterCtaClick={
        isFloating ? trackFloatingFabMasterCta : trackTickerStripClick
      }
    />
  );
};

export default OpenDematFloatBannerCtaClient;
